import { useMutation } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useDeleteAudienceById = () => {
  const dealership = useDealership()

  return useMutation(({ audience_id }: { audience_id: number }) =>
    request({
      url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/audiences/${audience_id}`,
      method: 'DELETE',
    }),
  )
}
